// import React from "react";

// const TrackPlayerContext = React.createContext({});

// export const TrackPlayerProvider = TrackPlayerContext.Provider;
// export const TrackPlayerConsumer = TrackPlayerContext.Consumer;
// export default TrackPlayerContext;

// https://blog.logrocket.com/use-hooks-and-context-not-react-and-redux/

// store.js
import React, { createContext, useReducer } from "react";

const initialState = { name: "", tracks: [], position: 0, playing: false, paused: false, currentTrack: {}, seeking: false };
const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
  let hasNextTrack = false;
  let playing = false;
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case "play":
        return { ...state, progress: 0, playing: true, paused: false };
      case "pause":
        return { ...state, seeking: false, playing: false, paused: true };
      case "toggle":
        return { ...state, seeking: false, playing: !state.playing, paused: !state.paused };
      case "stop":
        return { ...state, seeking: false, progress: 0, playing: false, paused: false, currentTrack: {} };
      case "rewind":
        let previous = state.position - 1;
        hasNextTrack = !!(previous >= 0);
        playing = hasNextTrack;
        if (!hasNextTrack) previous = 0;
        return { ...state, seeking: false, progress: 0, position: previous, currentTrack: state.tracks[previous], playing, paused: false };
      case "forward":
        let next = state.position + 1;
        hasNextTrack = !!(next >= 0 && next < state.tracks.length);
        playing = hasNextTrack;
        if (!hasNextTrack) next = 0;
        return { ...state, seeking: false, progress: 0, position: next, currentTrack: state.tracks[next], playing, paused: false };
      case "play_playlist":
        const newState = {
          ...state,
          ...action.playlist,
          progress: 0,
          position: 0,
          currentTrack: action.playlist.tracks[0],
          playing: true,
          paused: false,
        };
        return newState;
      case "track_seek":
        return { ...state, seeking: true, seekTo: action.seekTo };
      case "track_seek_complete":
        return { ...state, seeking: false };
      case "track_progress":
        return { ...state, progress: action.progress };
      case "load_playlist":
        return {
          ...state,
          ...action.playlist,
          seeking: false,
          progress: 0,
          position: 0,
          currentTrack: action.playlist.tracks[0],
          playing: action.playing,
          paused: false,
        };
      default:
        throw new Error();
    }
  }, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
